import { Dialog as MuiDialog, DialogProps as MuiDialogProps, useMediaQuery } from '@mui/material';
import { Theme } from '@mui/system';
import React, { FC, PropsWithChildren } from 'react';

import { DialogTitle } from './DialogTitle';

type Props = PropsWithChildren<{
  title?: React.ReactNode;
  onClose?: () => void;
  maxWidth?: MuiDialogProps['maxWidth'];
  fullWidth?: MuiDialogProps['fullWidth'];
  open?: boolean;
}>;

const Dialog: FC<Props> = ({ onClose, title, children, maxWidth, fullWidth, open }) => {
  const mobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <MuiDialog fullScreen={mobile} onClose={onClose} open={open ?? true} maxWidth={maxWidth} fullWidth={fullWidth}>
      {title && <DialogTitle onClose={onClose}>{title}</DialogTitle>}
      {children}
    </MuiDialog>
  );
};

export { Dialog };
